// BUDGET
export const BUDGET_OPTION = 'budget_option'
export const BUDGET_LIFETIME = 'budget_lifetime'
export const BUDGET_DAILY = 'budget_daily'
export const CAMPAIGN_BUDGET = 'campaign_budget'
